module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAV1JREFUWEftlyFLBEEUx/9v4MIdVuVUEExmg5/AIndxJimCQZMGLRrMgjZFowbhNO3E3aSfwGAyC4K6YBR2y7J/2bZhZ/X2xEOYqW/2vd/83ob3BGM+Mub6qAWIomgySZIjEVkGME/yR8AiQgDPJO87nc5hr9f7cD3UmTAMw26apo8AuiNaitvt9mK/34+r8jgBrLUDkmuO4tetVuuiHMuybJvkhuP+wBizPizAK8kZR8IXEXkox0guAZirLCLyprWeHQogCIKij792jDGVtp0tKAE8KaXumpDkeb4CYKH4tjGAiFxprTebAJT/Iw/gDXgD3oA34A14A97A/zUAYLwjmXOhEPkEcAxAkTwAMFE3tjVpwfs3S8muMeasKGqt3Sd5UgMQG2OmhxrLrbU3JFdrDGxprS+LeBAEOwDOa+7eaq0rl5xRVrNYKbUnIpLn+SnJKQdAs9WsSPYXy+kXgLdqMA+8NpsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user4.png
// module id = nJjt
// module chunks = 0